<template>
  <div>

    <v-row justify="space-between" v-if="provedor">
      <v-col class="align-self-center">
        <h3>{{ provedor.nome }}</h3>
      </v-col>

      <v-col md cols="4" class="align-self-center text-right">
        <SGPFormBotaoComponent color="primary" class="mr-2" @click="voltarParaLista">
          <v-icon small class="mr-2">mdi-arrow-left</v-icon>
          Voltar
        </SGPFormBotaoComponent>
        <ModosWebBotaoExportarComponent class="mr-2 d-inline-block" :campos="filtroAplicado"
          @exportar="handleExportarMultaProvedor" />
      </v-col>
    </v-row>

    <SGPRowComponent v-if="provedor">
      <SGPColComponent cols="12" style="display: flex;">
        <div style="width: 25%; margin: 10px;" v-for="card in totalizadores" :key="card.nome">
          <SGPBoxHeaderInfoComponent cor="branco" larguraMaxima="120%" class="main-box">
            <template #topCenter>
              <div class="text-center font-size-25">
                <span class="h1 main-title-pendente">{{ card.value }}</span>
              </div>
            </template>

            <template #contentCenter>
              <div class="text-center">
                <span class="main-title">{{ card.nome }}</span>
              </div>
            </template>
          </SGPBoxHeaderInfoComponent>
        </div>
      </SGPColComponent>
    </SGPRowComponent>

    <SGPRowComponent v-if="workflows.length">
      <SGPColComponent cols="12">

        <SGPPaginacaoComponent :paginacao="paginacaoWorkflows" @sgpAtualizarPaginacao="realizarPaginacao"
          :key="paginacaoWorkflows?.current_page || 1">
          <SGPTabelaAvancadaComponent :colunas="colunas" :dados="workflowsFormatados" :somenteLeitura="true"
            :selecionarColunas="true" :filtroText="true" />
        </SGPPaginacaoComponent>

      </SGPColComponent>
    </SGPRowComponent>

    <SGPAlertaComponent v-else>
      Nenhum workflow encontrado para este provedor.
    </SGPAlertaComponent>

    <SGPLoadingComponent v-if="loading" />

  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import ModosWebBotaoExportarComponent from '@/common/modosweb-components/ModosWebBotaoExportarComponent.vue';

export default {
  name: "CtrlProvedorDadosPage",

  components: {
    ModosWebBotaoExportarComponent
  },

  data() {
    return {
      loading: false,
      abrirFiltroAvancado: false,
      filtroAplicado: {},
      filtroKey: 1
    };
  },

  async created() {
    if (this.filtroData) {
      this.filtroAplicado = this.filtroData;
    }

    this.loading = true;
    await this.listarProvedorMulta(this.montarParametros());
    this.loading = false;
  },

  computed: {
    ...mapGetters("ctrlProvedoresMulta", [
      "provedor",
      "workflowsProvedor",
      "paginacaoWorkflows",
      "filtroData"
    ]),

    workflows() {
      return this.workflowsProvedor || [];
    },

    totalizadores() {
      if (!this.provedor) return [];
      return [
        { nome: "Total Multas (R$)", value: this.provedor.total_valor_multa || "0.00" },
        { nome: "SLA Excedido (min)", value: this.provedor.sla_excedente_minutos || 0 },
        { nome: "% SLA Excedido", value: this.provedor.sla_excedente_percentual || 0 },
        { nome: "Total de tickets com multa", value: this.provedor.total_pco_workflow_com_multa || 0 }
      ];
    },

    workflowsFormatados() {
      return this.workflows.map(item => ({
        visualizar_aba: `/workflow/ficha-tecnica-tarefa/${item.id}`,
        id: item.id,
        numero_rec: item.numero_rec,
        cliente_final: item.cliente_final,
        regional: this.provedor?.regional || "-",
        uf: this.provedor?.uf || "-",
        designacao_claro: item.designacao?.designacao,
        identificacao_acesso_provedor: item.identificacao_acesso_provedor,
        descricao_problema: item.descricao_problema,
        data_atendimento_cliente: item.data_atendimento_cliente
          ? moment(item.data_atendimento_cliente).format("DD/MM/YYYY HH:mm")
          : "-",
        data_abertura_ticket: item.data_abertura_ticket
          ? moment(item.data_abertura_ticket).format("DD/MM/YYYY HH:mm")
          : "-",
        data_agendamento: item.data_agendamento
          ? moment(item.data_agendamento).format("DD/MM/YYYY HH:mm")
          : "-",
        valor_multa: item.pco_workflow?.valor_multa ?? "-",
        sla: item.designacao?.sla ?? "-",
        sla_excedente_minutos_individual: item.sla_excedente_minutos_individual ?? "-",
      }));
    },

    colunas() {
      return [
        { key: "visualizar_aba", label: "Visualizar" },
        { key: "numero_rec", label: "Número REC" },
        { key: "cliente_final", label: "Cliente Final" },
        { key: "regional", label: "Região" },
        { key: "uf", label: "UF" },
        { key: "designacao_claro", label: "Designação Claro" },
        { key: "descricao_problema", label: "Descrição" },
        { key: "data_atendimento_cliente", label: "Atendimento Cliente" },
        { key: "data_abertura_ticket", label: "Abertura Ticket" },
        { key: "data_agendamento", label: "Agendamento" },
        { key: "valor_multa", label: "Valor Multa" },
        { key: "sla", label: "SLA designação (min)" },
        { key: "sla_excedente_minutos_individual", label: "SLA excedente (min)" },
      ];
    }
  },

  methods: {
    ...mapActions("ctrlProvedoresMulta", [
      "listarProvedorMulta",
      "exportarMultaProvedor"
    ]),

    async handleExportarMultaProvedor(dados) {
      await this.exportarMultaProvedor({
        ...dados.filtro,
        formato: dados.formato,
        ctrl_provedor_id: this.$route.params.ctrl_provedor_id
      });
    },

    voltarParaLista() {
      this.$router.push({ name: "ctrl-provedores-multa" });
    },

    montarParametros(extra = {}) {
      return {
        id: this.$route.params.ctrl_provedor_id,
        per_page: this.paginacaoWorkflows?.per_page || 20,
        page: this.paginacaoWorkflows?.current_page || 1,
        current_page: this.paginacaoWorkflows?.current_page || 1,
        ...this.filtroAplicado,
        ...extra
      };
    },

    async realizarPaginacao(paginate) {
      await this.listarProvedorMulta(
        this.montarParametros({
          page: paginate.current_page,
          current_page: paginate.current_page,
          per_page: paginate.per_page
        })
      );
    }
  }
};
</script>